<div class="medicines-wrapper">
  <iframe
    #pharmacyIframe
    [src]="pharmacyAppUrl"
    class="medicines-iframe"
    title="Pharmacy Management System">
  </iframe>
</div>
